var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var MoveToEndIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 65
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 64.4824C36.4183 64.4824 40 60.9007 40 56.4824C40 52.0641 36.4183 48.4824 32 48.4824C27.5817 48.4824 24 52.0641 24 56.4824C24 60.9007 27.5817 64.4824 32 64.4824Z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 12.4824C34.2091 12.4824 36 10.6916 36 8.48242C36 6.27328 34.2091 4.48242 32 4.48242C29.7909 4.48242 28 6.27328 28 8.48242C28 10.6916 29.7909 12.4824 32 12.4824ZM32 16.4824C36.4183 16.4824 40 12.9007 40 8.48242C40 4.06414 36.4183 0.482422 32 0.482422C27.5817 0.482422 24 4.06414 24 8.48242C24 12.9007 27.5817 16.4824 32 16.4824Z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 12.4824C58.2091 12.4824 60 10.6916 60 8.48242C60 6.27328 58.2091 4.48242 56 4.48242C53.7909 4.48242 52 6.27328 52 8.48242C52 10.6916 53.7909 12.4824 56 12.4824ZM56 16.4824C60.4183 16.4824 64 12.9007 64 8.48242C64 4.06414 60.4183 0.482422 56 0.482422C51.5817 0.482422 48 4.06414 48 8.48242C48 12.9007 51.5817 16.4824 56 16.4824Z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 36.4824C10.2091 36.4824 12 34.6916 12 32.4824C12 30.2733 10.2091 28.4824 8 28.4824C5.79086 28.4824 4 30.2733 4 32.4824C4 34.6916 5.79086 36.4824 8 36.4824ZM8 40.4824C12.4183 40.4824 16 36.9007 16 32.4824C16 28.0641 12.4183 24.4824 8 24.4824C3.58172 24.4824 0 28.0641 0 32.4824C0 36.9007 3.58172 40.4824 8 40.4824Z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 36.4824C34.2091 36.4824 36 34.6916 36 32.4824C36 30.2733 34.2091 28.4824 32 28.4824C29.7909 28.4824 28 30.2733 28 32.4824C28 34.6916 29.7909 36.4824 32 36.4824ZM32 40.4824C36.4183 40.4824 40 36.9007 40 32.4824C40 28.0641 36.4183 24.4824 32 24.4824C27.5817 24.4824 24 28.0641 24 32.4824C24 36.9007 27.5817 40.4824 32 40.4824Z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 36.4824C58.2091 36.4824 60 34.6916 60 32.4824C60 30.2733 58.2091 28.4824 56 28.4824C53.7909 28.4824 52 30.2733 52 32.4824C52 34.6916 53.7909 36.4824 56 36.4824ZM56 40.4824C60.4183 40.4824 64 36.9007 64 32.4824C64 28.0641 60.4183 24.4824 56 24.4824C51.5817 24.4824 48 28.0641 48 32.4824C48 36.9007 51.5817 40.4824 56 40.4824Z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 60.4824C10.2091 60.4824 12 58.6916 12 56.4824C12 54.2733 10.2091 52.4824 8 52.4824C5.79086 52.4824 4 54.2733 4 56.4824C4 58.6916 5.79086 60.4824 8 60.4824ZM8 64.4824C12.4183 64.4824 16 60.9007 16 56.4824C16 52.0641 12.4183 48.4824 8 48.4824C3.58172 48.4824 0 52.0641 0 56.4824C0 60.9007 3.58172 64.4824 8 64.4824Z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12.4824C10.2091 12.4824 12 10.6916 12 8.48242C12 6.27328 10.2091 4.48242 8 4.48242C5.79086 4.48242 4 6.27328 4 8.48242C4 10.6916 5.79086 12.4824 8 12.4824ZM8 16.4824C12.4183 16.4824 16 12.9007 16 8.48242C16 4.06414 12.4183 0.482422 8 0.482422C3.58172 0.482422 0 4.06414 0 8.48242C0 12.9007 3.58172 16.4824 8 16.4824Z"
  }));
};
export var MoveToEndIconGlyph = function (props) {
  return React.createElement(MoveToEndIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};